module.exports = __webpack_public_path__ + "static/media/control-diet-dieting-svgrepo-com.06243370.svg";